// extracted by mini-css-extract-plugin
export default {"main":"styles_main__8iLhi"};